import FrequentCoachingQuestions from './FrequentCoachingQuestions'
export default FrequentCoachingQuestions
